import React, { useEffect, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import formatDate from "../../common/Formatdate";
import Task from "../../assets/task.png";
import Completed from "../../assets/checked.png";
import Pending from "../../assets/work-in-progress.png";
import Urgent from "../../assets/alarm.png";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  IconButton,
  useMediaQuery,
  Typography,
  TablePagination,
  TextField,
  Autocomplete,
  Modal,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import commonapihandler from "../../common/commonapihandler";
import { getHubName } from "../../api/api";
import formatDateAndTime from "../../common/formatDateAndTime";
import { BlinkBlur } from "react-loading-indicators";
import toast from "react-hot-toast";
import moment from "moment";
import { camelToNormal } from "../../common/caseconversion";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import user from "../../assets/user.gif";

const imagestyle = {
  position: "fixed", // <--- change here
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 20,
  p: 4,
  overflowY: "auto",
  maxHeight: "80vh",
};

const Bookingconfigs = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const profile = JSON.parse(localStorage.getItem("profile"));
  let token = localStorage.getItem("token");
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);
  const [form, setForm] = useState({
    city: "",
    minbookinghrs: null,
    bookingbuffertime: null,
    mindeliverycharges: null,
    minpickupcharges: null,
    cancellationleadtime: null,
    minextensionhrs: null,
    maxextensionhrs: null,
    extensionperbooking: null,
    isHomeDeliveryDisabled: null,
    homeDeliveryBookingHr: null,
    shortSubscriptionHomeDelivery: null,
    isSubscriptionEnabled: null,
    isDailyRentalEnabled : null,
    bufferTimeEvCar : null,
    minBookingHrsEv : null
  });
  const [bookingCongfigsData, setBookingConfigs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState(null);
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectionRange, setSelectionRange] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });
  const [cityname, setCity] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getAllBookingConfigsData(0);
  }, [cityname]);

  const handleModalClose = () => {
    setSelectedRow(null);
    setForm({
      city: "",
      minbookinghrs: null,
      bookingbuffertime: null,
      mindeliverycharges: null,
      minpickupcharges: null,
      cancellationleadtime: null,
      minextensionhrs: null,
      maxextensionhrs: null,
      extensionperbooking: null,
      isHomeDeliveryDisabled: null,
      homeDeliveryBookingHr: null,
      shortSubscriptionHomeDelivery: null,
      isSubscriptionEnabled: null,
      isDailyRentalEnabled : null,
      bufferTimeEvCar : null,
      minBookingHrsEv : null
    });
    setOpenModal(false);
    setError("");
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  function createData(
    id,
    city,
    minbookinghrs,
    bookingbuffertime,
    bufferTimeEvCar,
    minBookingHrsEv,
    cancellationleadtime,
    isHomeDeliveryDisabled,
    homeDeliveryBookingHr,
    shortSubscriptionHomeDelivery,
    isSubscriptionEnabled,
    isDailyRentalEnabled,
    createdon,
    updatedon,
    action,
    raw,
  ) {
    return {
      id,
      city,
      minbookinghrs,
      bookingbuffertime,
      bufferTimeEvCar,
      minBookingHrsEv,
      cancellationleadtime,
      isHomeDeliveryDisabled,
      homeDeliveryBookingHr,
      shortSubscriptionHomeDelivery,
      isSubscriptionEnabled,
      isDailyRentalEnabled,
      createdon,
      updatedon,
      action,
      raw,
    };
  }

  const columns = [
    { id: "id", label: "Id", minWidth: 70, align: "left" },
    { id: "city", label: "City", minWidth: 70, align: "left" },
    {
      id: "minbookinghrs",
      label: "Min Booking Hrs",
      minWidth: 150,
      align: "right",
    },
    {
      id: "bookingbuffertime",
      label: "Booking Buffer Time",
      minWidth: 190,
      align: "right",
    },
    {
      id: "bufferTimeEvCar",
      label: "Booking Buffer Time for Ev Car",
      minWidth: 240,
      align: "right",
    },
    {
      id: "minBookingHrsEv",
      label: "Minimum Booking Hrs for Ev",
      minWidth: 240,
      align: "right",
    },
    {
      id: "cancellationleadtime",
      label: "Cancellation Lead Time",
      minWidth: 200,
      align: "right",
    },
    {
      id: "isHomeDeliveryDisabled",
      label: "Home Pickup & Delivery Disabled",
      minWidth: 250,
      align: "right",
    },
    {
      id: "homeDeliveryBookingHr",
      label: "Home Delivery Booking Hr",
      minWidth: 250,
      align: "right",
    },
    {
      id: "shortSubscriptionHomeDelivery",
      label: "Short Subscription Home Delivery",
      minWidth: 250,
      align: "right",
    },
    {
      id: "isSubscriptionEnabled",
      label: "Is Subscription Enabled",
      minWidth: 250,
      align: "right",
    },
    {
      id: "isDailyRentalEnabled",
      label: "Is Daily Rental Enabled",
      minWidth: 250,
      align: "right",
    },
    { id: "createdon", label: "Created On", minWidth: 190, align: "right" },
    { id: "updatedon", label: "Updated On", minWidth: 190, align: "right" },
    { id: "action", label: "Action", minWidth: 90, align: "right" },
  ];

  function formatDateForApi(date) {
    if (!date) return ""; // or undefined
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formatStartDate = selectionRange?.startDate
    ? formatDateForApi(selectionRange.startDate)
    : "";

  const formatEndDate = selectionRange?.endDate
    ? formatDateForApi(selectionRange.endDate)
    : "";

  const getAllBookingConfigsData = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
  ) => {
    setLoading(true);
    const offset = customPage * customRowsPerPage;
    let query = `limit=${customRowsPerPage}&offset=${offset}`;

    if (cityname) {
      query += `&cityId=${cityname}`;
    }

    try {
      const response = await fetch(`${apiUrl}/api/bookingconfigs?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setBookingConfigs(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const formatLocalISO = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate(),
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const handleDateChange = (field, value) => {
    if (!value) return;

    const date = new Date(value); // from <input type="date">
    if (field === "startDate") date.setHours(0, 0, 0, 0);
    if (field === "endDate") date.setHours(23, 59, 0, 0);

    setForm((prev) => ({
      ...prev,
      [field]: formatLocalISO(date), // <-- local datetime, no UTC shift
    }));
  };

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getAllBookingConfigsData();
  }, []);

  useEffect(() => {
    getCityNames();
  }, []);

  const rows =
    (bookingCongfigsData &&
      bookingCongfigsData?.map((item) =>
        createData(
          item?.id,
          cities[item?.cityId] || "-",
          item?.minBookingHrs || "-",
          item?.bufferTime || "-",
          item?.bufferTimeEvCar || "-",
          item?.minBookingHrsEv || "-",
          item?.cancellationLeadTime || "-",
          item?.isHomeDeliveryDisabled ? "True" : "False",
          item?.homeDeliveryBookingHr || "-",
          item?.shortSubscriptionHomeDelivery ? "True" : "False",
          item?.isSubscriptionEnabled ? "True" : "False",
          item?.isDailyRentalEnabled ? "True" : "False",
          formatDateAndTime(item?.createdAt) || "-",
          formatDateAndTime(item?.updatedAt) || "-",
          "Edit",
          item,
        ),
      )) ||
    [];

  const handleEditClick = (row) => {
    const raw = row.raw;
    setSelectedRow(raw);

    setForm({
      city: raw?.cityId,
      minbookinghrs: raw?.minBookingHrs,
      bookingbuffertime: raw?.bufferTime,
      mindeliverycharges: raw?.minDeliveryCharges,
      minpickupcharges: raw?.minPickupCharges,
      cancellationleadtime: raw?.cancellationLeadTime,
      minextensionhrs: raw?.minExtHrs,
      maxextensionhrs: raw?.maxExtHrs,
      extensionperbooking: raw?.extPerBooking,
      isHomeDeliveryDisabled: raw?.isHomeDeliveryDisabled,
      homeDeliveryBookingHr: raw?.homeDeliveryBookingHr,
      shortSubscriptionHomeDelivery: raw?.shortSubscriptionHomeDelivery,
      isSubscriptionEnabled: raw?.isSubscriptionEnabled,
      isDailyRentalEnabled : raw?.isDailyRentalEnabled,
      bufferTimeEvCar : raw?.bufferTimeEvCar,
      minBookingHrsEv : raw?.minBookingHrsEv
    });

    setOpenModal(true);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getAllBookingConfigsData(0, newRowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllBookingConfigsData(newPage, rowsPerPage);
  };

  const EditPeakSeasonDetails = async () => {
    if (
      !form.city ||
      !form.minbookinghrs ||
      !form.bookingbuffertime ||
      !form?.mindeliverycharges ||
      !form.minpickupcharges ||
      !form.cancellationleadtime ||
      !form.minextensionhrs ||
      !form.maxextensionhrs ||
      !form.extensionperbooking ||
      !form.homeDeliveryBookingHr ||
      !form?.bufferTimeEvCar || !form?.minBookingHrsEv
    ) {
      return setError("Please fill all the details");
    }
    let payload;

    if (selectedRow) {
      payload = {
        id: selectedRow.id,
        cityId: form.city,
        minBookingHrs: form.minbookinghrs,
        bufferTime: form.bookingbuffertime,
        minDeliveryCharges: form?.mindeliverycharges,
        minPickupCharges: form.minpickupcharges,
        cancellationLeadTime: form.cancellationleadtime,
        minExtHrs: form.minextensionhrs,
        maxExtHrs: form?.maxextensionhrs,
        extPerBooking: form?.extensionperbooking,
        isHomeDeliveryDisabled: form?.isHomeDeliveryDisabled,
        homeDeliveryBookingHr: form?.homeDeliveryBookingHr,
        shortSubscriptionHomeDelivery: form?.shortSubscriptionHomeDelivery,
        isSubscriptionEnabled: form?.isSubscriptionEnabled,
        isDailyRentalEnabled : form?.isDailyRentalEnabled,
        bufferTimeEvCar : form?.bufferTimeEvCar,
        minBookingHrsEv : form?.minBookingHrsEv
      };
    } else {
      payload = {
        cityId: Number(form.city),
        minBookingHrs: Number(form.minbookinghrs),
        bufferTime: Number(form.bookingbuffertime),
        minDeliveryCharges: Number(form?.mindeliverycharges),
        minPickupCharges: Number(form.minpickupcharges),
        cancellationLeadTime: Number(form.cancellationleadtime),
        minExtHrs: Number(form.minextensionhrs),
        maxExtHrs: Number(form?.maxextensionhrs),
        extPerBooking: Number(form?.extensionperbooking),
        isHomeDeliveryDisabled: form?.isHomeDeliveryDisabled,
        homeDeliveryBookingHr: Number(form?.homeDeliveryBookingHr),
        shortSubscriptionHomeDelivery: form?.shortSubscriptionHomeDelivery,
        isSubscriptionEnabled: form?.isSubscriptionEnabled,
        isDailyRentalEnabled : form?.isDailyRentalEnabled,
        bufferTimeEvCar : form?.bufferTimeEvCar,
        minBookingHrsEv : form?.minBookingHrsEv
      };
    }
    try {
      const response = await fetch(`${apiUrl}/api/bookingconfigs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data?.statusCode === "0100") {
        await getAllBookingConfigsData();
        setForm({
          city: "",
          minbookinghrs: null,
          bookingbuffertime: null,
          mindeliverycharges: null,
          minpickupcharges: null,
          cancellationleadtime: null,
          minextensionhrs: null,
          maxextensionhrs: null,
          extensionperbooking: null,
          isHomeDeliveryDisabled: null,
          homeDeliveryBookingHr: null,
          shortSubscriptionHomeDelivery: null,
          isSubscriptionEnabled: null,
          isDailyRentalEnabled: null,
          bufferTimeEvCar : null,
          minBookingHrsEv : null
        });
        setError("");
        setOpenModal(false);
      } else {
        toast.error(data?.message);
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error during approval:", error);
    }

    // send to API here
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
  };

  return (
    <div>
      {openModal && selectedRow ? (
        <Modal open={!!openModal} onClose={handleModalClose}>
          <Box sx={imagestyle}>
            <h1 className="text-xl mb-4">Update Booking Config</h1>
            <div className="space-y-6 mt-8">
              <div className="grid grid-cols-3 gap-4">
                <TextField
                  fullWidth
                  label="City"
                  required
                  disabled
                  value={cities[form.city]}
                  onChange={(e) => handleChange("city", e.target.value)}
                />

                <TextField
                  fullWidth
                  type="number"
                  label="Min Booking Hrs"
                  value={form.minbookinghrs}
                  onChange={(e) =>
                    handleChange("minbookinghrs", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  label=" Booking Buffer Hrs"
                  required
                  value={form.bookingbuffertime}
                  onChange={(e) =>
                    handleChange("bookingbuffertime", e.target.value)
                  }
                />

                  <TextField
                  fullWidth
                  type="number"
                  label="Min Booking Hrs for EV Car"
                  value={form.minBookingHrsEv}
                  onChange={(e) =>
                    handleChange("minBookingHrsEv", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  label="Booking Buffer Hrs for EV Car"
                  required
                  value={form.bufferTimeEvCar}
                  onChange={(e) =>
                    handleChange("bufferTimeEvCar", e.target.value)
                  }
                />

                <TextField
                  fullWidth
                  label="Min Delivery Charges"
                  required
                  value={form.mindeliverycharges}
                  onChange={(e) =>
                    handleChange("mindeliverycharges", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  label="Min Pickup Charges"
                  required
                  value={form.minpickupcharges}
                  onChange={(e) =>
                    handleChange("minpickupcharges", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  label="Cancellation Lead Time"
                  required
                  value={form.cancellationleadtime}
                  onChange={(e) =>
                    handleChange("cancellationleadtime", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  label="Min Extension Hrs"
                  required
                  value={form.minextensionhrs}
                  onChange={(e) =>
                    handleChange("minextensionhrs", e.target.value)
                  }
                />

                <TextField
                  fullWidth
                  label="Max Extension Hrs"
                  required
                  value={form.maxextensionhrs}
                  onChange={(e) =>
                    handleChange("maxextensionhrs", e.target.value)
                  }
                />

                <TextField
                  fullWidth
                  label="Extension Per Booking"
                  required
                  value={form.extensionperbooking}
                  onChange={(e) =>
                    handleChange("extensionperbooking", e.target.value)
                  }
                />
                <FormControl fullWidth>
                  <InputLabel id="isHomeDeliveryDisabledlabel">
                    Home Pickup & Delivery Disabled
                  </InputLabel>
                  <Select
                    labelId="isHomeDeliveryDisabledlabel"
                    value={form.isHomeDeliveryDisabled}
                    onChange={(e) =>
                      handleChange("isHomeDeliveryDisabled", e.target.value)
                    }
                    label="delivery"
                  >
                    <MenuItem key={true} value={true}>
                      True
                    </MenuItem>
                    <MenuItem key={false} value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="shortSubscriptionHomeDeliverylabel">
                    Subscription Home Delivery
                  </InputLabel>
                  <Select
                    labelId="shortSubscriptionHomeDeliverylabel"
                    value={form.shortSubscriptionHomeDelivery}
                    onChange={(e) =>
                      handleChange(
                        "shortSubscriptionHomeDelivery",
                        e.target.value,
                      )
                    }
                    label="subscription"
                  >
                    <MenuItem key={true} value={true}>
                      True
                    </MenuItem>
                    <MenuItem key={false} value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="isSubscriptionEnabled">
                    Subscription Enabled
                  </InputLabel>
                  <Select
                    labelId="isSubscriptionEnabled"
                    value={form.isSubscriptionEnabled}
                    onChange={(e) =>
                      handleChange("isSubscriptionEnabled", e.target.value)
                    }
                    label="isSubscriptionEnabled"
                  >
                    <MenuItem key={true} value={true}>
                      True
                    </MenuItem>
                    <MenuItem key={false} value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="isDailyRentalEnabled">
                    Daily Rental Enabled
                  </InputLabel>
                  <Select
                    labelId="isDailyRentalEnabled"
                    value={form.isDailyRentalEnabled}
                    onChange={(e) =>
                      handleChange("isDailyRentalEnabled", e.target.value)
                    }
                    label="isDailyRentalEnabled"
                  >
                    <MenuItem key={true} value={true}>
                      True
                    </MenuItem>
                    <MenuItem key={false} value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label="Home Delivery Booking Hr"
                  required
                  value={form.homeDeliveryBookingHr}
                  onChange={(e) =>
                    handleChange("homeDeliveryBookingHr", e.target.value)
                  }
                />
              </div>
            </div>
            {error && <p className="text-red-600 text-center mt-6">{error}</p>}
            <div className="flex justify-center mt-10">
              <button
                onClick={() => {
                  EditPeakSeasonDetails();
                }}
                class="cursor-pointer bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border-[1px] border-slate-500 text-white font-medium group"
              >
                <div class="relative overflow-hidden">
                  <p class="group-hover:-translate-y-7 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    Update
                  </p>
                  <p class="absolute top-7 left-0 group-hover:top-0 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    Update
                  </p>
                </div>
              </button>
            </div>
          </Box>
        </Modal>
      ) : (
        <Modal open={!!openModal} onClose={handleModalClose}>
          <Box sx={imagestyle}>
            <h1 className="text-xl mb-4">Create New Booking Config</h1>
            <div className="space-y-6 mt-8">
              <div className="grid grid-cols-3 gap-4">
                <FormControl fullWidth>
                  <InputLabel id="city-label">City</InputLabel>
                  <Select
                    labelId="city-label"
                    value={form.city}
                    onChange={(e) => handleChange("city", e.target.value)}
                    label="City"
                  >
                    {cities &&
                      Object.entries(cities).map(([key, value]) => (
                        <MenuItem key={key} value={key}>
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  type="number"
                  label="Min Booking Hrs"
                  value={form.minbookinghrs}
                  onChange={(e) =>
                    handleChange("minbookinghrs", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  type="number"
                  label=" Booking Buffer Hrs"
                  required
                  value={form.bookingbuffertime}
                  onChange={(e) =>
                    handleChange("bookingbuffertime", e.target.value)
                  }
                />

                   <TextField
                  fullWidth
                  type="number"
                  label="Min Booking Hrs for EV Car"
                  value={form.minBookingHrsEv}
                  onChange={(e) =>
                    handleChange("minBookingHrsEv", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  label="Booking Buffer Hrs for EV Car"
                  required
                  value={form.bufferTimeEvCar}
                  onChange={(e) =>
                    handleChange("bufferTimeEvCar", e.target.value)
                  }
                />

                <TextField
                  fullWidth
                  type="number"
                  label="Min Delivery Charges"
                  required
                  value={form.mindeliverycharges}
                  onChange={(e) =>
                    handleChange("mindeliverycharges", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  type="number"
                  label="Min Pickup Charges"
                  required
                  value={form.minpickupcharges}
                  onChange={(e) =>
                    handleChange("minpickupcharges", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  type="number"
                  label="Cancellation Lead Time"
                  required
                  value={form.cancellationleadtime}
                  onChange={(e) =>
                    handleChange("cancellationleadtime", e.target.value)
                  }
                />
                <TextField
                  fullWidth
                  type="number"
                  label="Min Extension Hrs"
                  required
                  value={form.minextensionhrs}
                  onChange={(e) =>
                    handleChange("minextensionhrs", e.target.value)
                  }
                />

                <TextField
                  fullWidth
                  type="number"
                  label="Max Extension Hrs"
                  required
                  value={form.maxextensionhrs}
                  onChange={(e) =>
                    handleChange("maxextensionhrs", e.target.value)
                  }
                />

                <TextField
                  fullWidth
                  type="number"
                  label="Extension Per Booking"
                  required
                  value={form.extensionperbooking}
                  onChange={(e) =>
                    handleChange("extensionperbooking", e.target.value)
                  }
                />
                <FormControl fullWidth>
                  <InputLabel id="isHomeDeliveryDisabledlabel">
                    Home Pickup & Delivery Disabled
                  </InputLabel>
                  <Select
                    labelId="isHomeDeliveryDisabledlabel"
                    value={form.isHomeDeliveryDisabled}
                    onChange={(e) =>
                      handleChange("isHomeDeliveryDisabled", e.target.value)
                    }
                    label="delivery"
                  >
                    <MenuItem key={true} value={true}>
                      True
                    </MenuItem>
                    <MenuItem key={false} value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="shortSubscriptionHomeDeliverylabel">
                    Subscription Home Delivery
                  </InputLabel>
                  <Select
                    labelId="shortSubscriptionHomeDeliverylabel"
                    value={form.shortSubscriptionHomeDelivery}
                    onChange={(e) =>
                      handleChange(
                        "shortSubscriptionHomeDelivery",
                        e.target.value,
                      )
                    }
                    label="subscription"
                  >
                    <MenuItem key={true} value={true}>
                      True
                    </MenuItem>
                    <MenuItem key={false} value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="isSubscriptionEnabled">
                    Subscription Enabled
                  </InputLabel>
                  <Select
                    labelId="isSubscriptionEnabled"
                    value={form.isSubscriptionEnabled}
                    onChange={(e) =>
                      handleChange("isSubscriptionEnabled", e.target.value)
                    }
                    label="isSubscriptionEnabled" 
                  >
                    <MenuItem key={true} value={true}>
                      True
                    </MenuItem>
                    <MenuItem key={false} value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="isDailyRentalEnabled">
                    Daily Rental Enabled
                  </InputLabel>
                  <Select
                    labelId="isDailyRentalEnabled"
                    value={form.isDailyRentalEnabled}
                    onChange={(e) =>
                      handleChange("isDailyRentalEnabled", e.target.value)
                    }
                    label="isDailyRentalEnabled" 
                  >
                    <MenuItem key={true} value={true}>
                      True
                    </MenuItem>
                    <MenuItem key={false} value={false}>
                      False
                    </MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label="Home Delivery Booking Hr"
                  required
                  value={form.homeDeliveryBookingHr}
                  onChange={(e) =>
                    handleChange("homeDeliveryBookingHr", e.target.value)
                  }
                />
              </div>
            </div>
            {error && <p className="text-red-600 text-center mt-6">{error}</p>}
            <div className="flex justify-center mt-10">
              <button
                onClick={() => {
                  EditPeakSeasonDetails();
                }}
                class="cursor-pointer bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border-[1px] border-slate-500 text-white font-medium group"
              >
                <div class="relative overflow-hidden">
                  <p class="group-hover:-translate-y-7 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    Add
                  </p>
                  <p class="absolute top-7 left-0 group-hover:top-0 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    Add
                  </p>
                </div>
              </button>
            </div>
          </Box>
        </Modal>
      )}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div className="flex items-center justify-between mt-6">
          <div className="flex items-center gap-4">
            <img className="w-20 h-20 rounded-full" src={user} alt="User" />
            <h1 className="text-2xl font-bold">
              Welcome back, {profile?.name}!
            </h1>
          </div>
        </div>
        <button
          onClick={() => {
            setOpenModal(true);
          }}
          className="rounded-lg relative h-10 cursor-pointer flex items-center border border-green-500 bg-green-500 group hover:bg-green-500 active:bg-green-500 active:border-green-500 px-4"
        >
          <span className="text-gray-200 font-semibold mr-4 transform group-hover:translate-x-2 transition-all duration-300">
            New Booking Config
          </span>
          <span className="absolute right-0 h-full w-10 rounded-lg bg-green-500 flex items-center justify-center transform group-hover:translate-x-0 group-hover:w-full transition-all duration-300">
            <svg
              className="svg w-8 text-white"
              fill="none"
              height="24"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              width="24"
            >
              <line x1="12" x2="12" y1="5" y2="19"></line>
              <line x1="5" x2="19" y1="12" y2="12"></line>
            </svg>
          </span>
        </button>
      </div>

      {/* <Box
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          lg: "repeat(7, 1fr)",
        }}
        gap={2}
        mb={3}
      >
        <h1 className="mt-2">Filter By :</h1>

        <FormControl fullWidth size="small">
          <InputLabel id="city-select-label">City</InputLabel>
          <Select
            labelId="city-select-label"
            id="city-select"
            value={cityname}
            onChange={handleCityChange}
          >
            {cities &&
              Object.entries(cities).map(([key, value]) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box> */}

      {/* <div className="w-full sm:w-auto flex justify-end sm:ml-auto gap-4 mt-16 sm:mt-0">
        <button
          onClick={() => {
            setCity(null);
          }}
          className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
        >
          Reset
        </button>
      </div> */}

      <Paper
        sx={{
          // width: "80%",
          boxShadow: 6,
          borderRadius: 2,
          mt: 4,
        }}
      >
        <TableContainer
          sx={{
            // maxHeight: 500,
            overflowX: "scroll", // ✅ horizontal scroll only if needed
          }}
        >
          <Table stickyHeader aria-label="bookings table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#f8f7f6ff",
                      fontWeight: 300,
                    }}
                    key={column.id}
                    align={column.align || "left"}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <div className="flex flex-col items-center h-40 justify-center">
                      <BlinkBlur
                        color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ) : rows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <h1 className="mt-10 text-lg font-bold">No Data Found</h1>
                  </TableCell>
                </TableRow>
              ) : (
                rows.map((row, idx) => (
                  <TableRow hover key={idx}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          sx={{
                            ...(column.id === "inquiryaging"
                              ? {
                                  color: "#fc7070ff",
                                  fontWeight: 900,
                                }
                              : {}),
                            ...(column.id === "active"
                              ? {
                                  color:
                                    value === "True"
                                      ? "#0bf80bff"
                                      : "#f3280eff",
                                  fontWeight: 900,
                                }
                              : {}),
                          }}
                          //   onClick={() => handleViewClick(row)}
                          key={column.id}
                          align={column.align}
                        >
                          {column.id === "action" ? (
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => handleEditClick(row)}
                            >
                              Edit
                            </Button>
                          ) : (
                            value || "-"
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[20, 30, 40]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            ".MuiTablePagination-toolbar": {
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
            },
          }}
        />
      </Paper>
    </div>
  );
};

export default Bookingconfigs;
